var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamepadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57215 0.279035C3.1872 -0.0594592 0.25 2.59867 0.25 6.0005V11.9411C0.25 16.5049 6.12464 18.3567 8.74178 14.6179L9.02602 14.2119C10.1877 12.5523 12.6641 12.6095 13.7479 14.3209C16.0724 17.9911 21.75 16.3444 21.75 12V6.0005C21.75 2.59867 18.8128 -0.059459 15.4279 0.279035L11.5224 0.669581C11.175 0.704321 10.825 0.704321 10.4776 0.669581L6.57215 0.279035ZM18 5.97552C18 6.52781 17.5523 6.97552 17 6.97552C16.4477 6.97552 16 6.52781 16 5.97552C16 5.42324 16.4477 4.97552 17 4.97552C17.5523 4.97552 18 5.42324 18 5.97552ZM15 9.97552C15.5523 9.97552 16 9.52781 16 8.97552C16 8.42324 15.5523 7.97552 15 7.97552C14.4477 7.97552 14 8.42324 14 8.97552C14 9.52781 14.4477 9.97552 15 9.97552ZM7 4.72552C7.41421 4.72552 7.75 5.06131 7.75 5.47552V6.72552H9C9.41421 6.72552 9.75 7.06131 9.75 7.47552C9.75 7.88974 9.41421 8.22552 9 8.22552H7.75V9.47552C7.75 9.88974 7.41421 10.2255 7 10.2255C6.58579 10.2255 6.25 9.88974 6.25 9.47552V8.22552H5C4.58579 8.22552 4.25 7.88974 4.25 7.47552C4.25 7.06131 4.58579 6.72552 5 6.72552H6.25V5.47552C6.25 5.06131 6.58579 4.72552 7 4.72552Z",
    fill: "#2A2A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadBlack);
export default __webpack_public_path__ + "static/media/Gamepad_black.0079c87eddb991cd2a3c6e4eeb564815.svg";
export { ForwardRef as ReactComponent };